import { StatsApiClient } from "../../clients/stats-client";
import { Product } from "./models/products";

export class ProductsRepository {
    private _client: StatsApiClient;

    constructor() {
        this._client = new StatsApiClient('/api/v2/products');
    }

    async get(id: string): Promise<ApiDataResponse<Product>> {
        return await this._client.get<Product>("", {
            productId: id
        });
    }

    async getAll(): Promise<ApiDataResponse<Product[]>> {
        return await this._client.get<Product[]>("all");
    }

    async getDotaPlus(): Promise<ApiDataResponse<Product[]>> {
        return await this._client.get<Product[]>("dota-plus");
    }

    async getShards(): Promise<ApiDataResponse<Product[]>> {
        return await this._client.get<Product[]>("shards");
    }
}